<script>
  import _debounce from 'lodash/debounce'
  export default {
    props: {
      // value: {
      //   type: String,
      //   default: ''
      // },
      title: {
        type: String,
        default: ''
      },
      list: {
        type: Array,
        default: () => {
          return []
        }
      },
      disableLink: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        activeCategory: this.$route.params.categoryAlias || this.$route.query.categoryAlias || '',
      }
    },
    mounted() {
      const initData = () => {
        // if(!this.activeCategory && this.list.length > 0) {
        //   this.activeCategory = this.list[0].text
        // }
      };

      initData();

    },
    methods: {
      onChangeCategory(categoryAlias) {
        /* this.$router.push({
         name: this.$route.name,
         params: {
         categoryAlias: this.activeCategory
         },
         }) */
        const params = () => {
          switch(this.$route.name) {
            case 'brand-category':
            case 'brand-list':
              return {
                query: {
                  ...this.$route.query.query,
                },
                params: {
                  categoryAlias
                }
              }
            default:
              return {
                query: {
                  ...this.$route.query.query,
                  categoryAlias
                },
              }
          }
        }

        this.$router.push({
          name: this.$route.name === 'brand-list'
            ? 'brand-category'
            : this.$route.name,
          ...params()

        })
      },
      onClickCategory(categoryAlias) {
        this.$router.push({
          name: this.$route.name,
          query: {
            ...this.$route.query,
            categoryAlias,
            page: 1,
          },
        })
      },
      changeFilter: _debounce(function () {
        // const value = this.$refs.filter.getCheckedKeys()
        //   .filter((id) => id);


        // setWindowHistory({
        //   query: {
        //     ...this.$route.query,
        //     [this.name]: value.join(',') || undefined
        //   }
        // });

        this.$emit('input', this.activeCategory);

        // if(this.type === 'prompt') {
        //   this.$emit('change', value);
        // }
      }, 600),
    }
  }
</script>
<template>
  <div :class="$style.baseMenuCategory">
    <div class="d-none d-lg-block">
      <div class="baseMenuCategory__title">
        {{ title }}
      </div>
      <ul class="baseMenuCategory__menuList">
        <li
          v-for="(item, index) in list"
          :key="index"
          class="baseMenuCategory__menuList__item"
        >
          <router-link
            v-if="!disableLink"
            :to="{ 
              name: 'brand-category',
              params: {
                categoryAlias: item.alias,
                categoryTitle: item.title,
              },
              query: {
                ...$route.query,
              },
            }"
            class="baseMenuCategory__menuList__link"
            :class="{ 'router-link-exact-active': activeCategory === item.alias }"
          >
            {{ item.title }}
          </router-link>
          <a
            v-else
            class="baseMenuCategory__menuList__link"
            style="cursor: pointer;"
            :class="{ 'router-link-exact-active': activeCategory ? activeCategory === item.alias : item.alias === '*' }"
            @click="onClickCategory(item.alias)"
          >
            {{ item.title }}
          </a>
        </li>
      </ul>
    </div>
    <div class="baseMenuCategory__selectCategory">
      <el-select
        v-model="activeCategory"
        class="isStyleMenu"
        @change="onChangeCategory"
      >
        <el-option
          v-for="(item, index) in list"
          :key="item.text"
          :label="item.title"
          :value="item.alias">
        </el-option>
      </el-select>
    </div>
    <div class="d-block d-md-none">
      <div class="d-md-none d-block my-4 font-medium text-xl">
        {{ title }}
      </div>
        <el-radio-group 
          v-model="activeCategory"
          class="isStyleBase isMobile"
          @change="changeFilter"
        >
        <el-radio
          v-for="(item, $index) in list"
          :key="$index"
          :label="item.alias">
          {{item.title}}
        </el-radio>
      </el-radio-group>
    </div>
  </div>
</template>
<style lang="scss" module>
  .baseMenuCategory {
    :global {
      .baseMenuCategory {
        &__title {
          margin-bottom: 1.875rem;
          font-size: 1.5rem;
          font-weight: 500;
        }
        &__selectCategory {
          display: none;
          @include max-lg {
            display: block
          }
          @include max-md {
            display: none
          }
        }
        &__menuList {
          @include list-unstyled;

          margin-bottom: -1.2rem;

          &__item {
            padding-left: 1.3rem;
            margin-bottom: 1.2rem;
          }

          &__link {
            display: block;
            color: $color-gray-6;
            letter-spacing: 0.15em;
            cursor: pointer;
            transition: .3s;

            &.router-link-exact-active {
              color: $color-primary
            }

            &.isActive, &:hover, &:active {
              color: $color-primary;
              text-decoration: none;
            }
          }
        }
      }
    }
  }
</style>
